import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(() => ({
  loading: {
    display: "flex",
    justifyContent: "center",
    width: "40%",
  },
  iconLoading: {
    color: "#028B7E",
  },
  containerChoiseFilter: {
    marginLeft: "1rem",
  },
  optionContainer: {
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    color: "#5c6865",
  },
  p: {
    paddingLeft: 10,
    fontWeight: "bold",
  },
}))

export default useStyles
